import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const ResetPasswordButton = () => {
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    await navigate('/request-reset-password');
  };
  return (
    <ChakraV3.Button
      onClick={handleForgotPassword}
      variant='plain'
      w='fit-content'
      cursor='pointer'
    >
      Forgot your password?
    </ChakraV3.Button>
  );
};
